import * as React from 'react';
import { Image } from './layout/Image';

export function Spinner() {      
    return (
        <Image className='spinner' source={'spinner.gif'} />
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/Spinner.tsx